/**
 * The inventory's public API, unchanged in shape since the app was built.
 *
 * It used to be localStorage; it is now IndexedDB behind a synchronous cache
 * (`itemStore.ts`). This file exists so that nothing above it had to notice:
 * every component and every test still calls `loadFoodItems()` and gets an
 * array back.
 *
 * `StorageError` survives for the one caller that still throws synchronously —
 * the shopping list, which is small enough to belong in localStorage.
 */

export {
  loadFoodItems,
  replaceFoodItems,
  saveFoodItem,
  deleteFoodItem,
  reportPersistErrorsTo,
  hydrateItems,
  isHydrated,
  resetItemCacheForTests,
} from "./itemStore";

/** A save that failed for a reason worth showing the user. */
export class StorageError extends Error {
  name = "StorageError";
}

/**
 * crypto.randomUUID is missing over plain http and in older browsers, so fall
 * back to time plus randomness — unique enough for one person's local list.
 */
export function createId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `item-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
